import _toConsumableArray from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import { getLocalDateFromTimezone, logger, isToday } from '@tradingblock/api';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import _ from 'lodash';
import { DEFAULT_TRADINGSESSION } from './constants';
import { handleUpdates, subscribeOnStream, unsubscribeFromStream } from './streaming';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
dayjs.extend(LocalizedFormat);
dayjs.extend(utc);
var AllSupportedResolutions = ['1', '5', '15', '30', '60', '1D'];
var lastBarsCache = new Map();
var symbolInfoCache = new Map();
var listenerGUIDCache = new Map();
export var TradingViewDataFeed = function TradingViewDataFeed(api) {
  var _this = this;

  _classCallCheck(this, TradingViewDataFeed);

  this.onReady = function (callback) {
    var config = {
      supports_marks: false,
      supports_timescale_marks: false,
      supports_time: true,
      supported_resolutions: AllSupportedResolutions
    };
    setTimeout(function () {
      return callback(config);
    });
  };

  this.searchSymbols =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(userInput, exchange, symbolType, onResult) {
      var query, symbols, newSymbols, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              query = userInput ? userInput.trim() : '';
              _context.next = 3;
              return _this.api.getSymbols({
                query: query
              }, 200);

            case 3:
              symbols = _context.sent;
              newSymbols = symbols.filter(function (symbol) {
                var isExchangeValid = exchange === '' || symbol.PrimaryExchange === exchange;
                var isFullSymbolContainsInput = symbol.Symbol.indexOf(query.toUpperCase()) !== -1;
                return isExchangeValid && isFullSymbolContainsInput;
              });
              data = newSymbols.map(function (symbol) {
                return {
                  symbol: symbol.Symbol,
                  full_name: symbol.Symbol,
                  description: symbol.Description,
                  exchange: symbol.PrimaryExchange,
                  ticker: symbol.Symbol,
                  type: symbol.Type
                };
              });
              onResult(data);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }();

  this.resolveSymbol = function (symbol, onResolve, onError) {
    var _$split = _.split(symbol, ':'),
        _$split2 = _slicedToArray(_$split, 2),
        exchange = _$split2[0],
        symbolName = _$split2[1]; // fallback to symbol passed in if no value after colon


    var symbolValue = symbolName || symbol;

    _this.api.getSymbols({
      query: symbolValue
    }, 1).then(function (symbolRes) {
      var match = _.find(symbolRes, function (s) {
        return s.Symbol && symbolValue && s.Symbol.trim().toLowerCase() === symbolValue.trim().toLowerCase();
      });

      var symbol = match || _.first(symbolRes);

      if (symbol) {
        _this.symbol = symbol.Symbol;
        var res = {
          format: 'price',
          name: symbol.Symbol,
          full_name: symbol.Symbol,
          description: symbol.Description,
          ticker: symbol.Symbol,
          exchange: symbol.PrimaryExchange,
          listed_exchange: symbol.PrimaryExchange,
          supported_resolutions: AllSupportedResolutions,
          type: symbol.Type,
          session: DEFAULT_TRADINGSESSION,
          minmov: 1,
          minmove2: 0,
          pricescale: 100,
          timezone: 'America/New_York',
          has_intraday: true,
          has_daily: true,
          has_weekly_and_monthly: false,
          currency_code: '$',
          data_status: 'streaming'
        };
        onResolve(res);
      } else {
        onError('couldnt find symbol');
      }
    });
  };

  this.getPeriodForResolution = function (res) {
    if (['1', '5', '15', '30'].includes(res)) {
      return "M".concat(res);
    } else if (res === '60') {
      return 'H1';
    } else {
      return 'Day';
    }
  };

  this.getBars =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(symbolInfo, resolution, periodParams, onResult, onError) {
      var rangeStartDate, rangeEndDate, firstDataRequest, period, starttime, endtime, maxDate, minDate, data, bars;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              rangeStartDate = periodParams.from, rangeEndDate = periodParams.to, firstDataRequest = periodParams.firstDataRequest;
              period = _this.getPeriodForResolution(resolution);
              starttime = getLocalDateFromTimezone(dayjs.unix(rangeStartDate)).toDate();
              endtime = getLocalDateFromTimezone(dayjs.unix(rangeEndDate)).toDate();

              if (endtime.valueOf() > _this.api.marketClose.valueOf()) {
                endtime = _this.api.marketClose;
              }

              maxDate = undefined;
              minDate = undefined;
              _context2.prev = 7;
              _context2.next = 10;
              return _this.api.getBars({
                symbol: symbolInfo.name,
                period: period,
                starttime: starttime,
                endtime: endtime
              });

            case 10:
              data = _context2.sent;

              // nextTime should be equal to 2 weeks before the first bar in the response
              if (data.length === 0) {
                onResult([], {
                  noData: true,
                  nextTime: rangeStartDate - 1209600
                });
              }

              bars = [];
              data.forEach(function (bar) {
                var bdate;
                var dateString = bar.D.toString();

                if (isToday(bar.D)) {
                  bdate = getLocalDateFromTimezone(dayjs(dateString));
                } else {
                  bdate = getLocalDateFromTimezone(dayjs(bar.D));
                }

                maxDate = maxDate === undefined ? bdate : bdate > maxDate ? bdate : maxDate;
                minDate = minDate === undefined || bdate < minDate ? bdate : minDate;
                bars = [].concat(_toConsumableArray(bars), [{
                  time: bdate.utc().valueOf(),
                  low: bar.L,
                  high: bar.H,
                  open: bar.O,
                  close: bar.C,
                  volume: bar.V
                }]);
                _this.bars = bars;
              });

              if (firstDataRequest) {
                // set lastBarsCache equal to the last bar in the response that is within the range
                if (bars[bars.length - 1] !== undefined) {
                  lastBarsCache.set("".concat(symbolInfo.name, "~").concat(resolution), bars[bars.length - 1]);
                }
              }

              onResult(bars, {
                noData: false
              });
              _context2.next = 21;
              break;

            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](7);
              onError(_context2.t0);

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[7, 18]]);
    }));

    return function (_x5, _x6, _x7, _x8, _x9) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.subscribeBars =
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(symbolInfo, resolution, onTick, listenerGuid, onResetCacheNeededCallback) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this.subscribeBarsCallback = onTick;
              _this.resetCacheCallback = onResetCacheNeededCallback;
              _this.resolution = resolution;
              _this.listenToQuotes = true;
              symbolInfoCache.set("".concat(symbolInfo.name, "~").concat(resolution), symbolInfo);
              listenerGUIDCache.set("".concat(symbolInfo.name, "~").concat(resolution), listenerGuid);

              _this.symbols.push(symbolInfo.name);

              subscribeOnStream(symbolInfo, resolution, onTick, listenerGuid, onResetCacheNeededCallback, lastBarsCache.get("".concat(symbolInfo.name, "~").concat(resolution)));

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x10, _x11, _x12, _x13, _x14) {
      return _ref3.apply(this, arguments);
    };
  }();

  this.unsubscribeBars = function (listenerGuid) {
    _this.listenToQuotes = false;
    _this.bars = [];
    unsubscribeFromStream(listenerGuid);
  };

  this.isNextBar = function (latestExistingDate, nextDate, resolution) {
    return latestExistingDate.unix() < nextDate.unix();
  };

  this.resetCache = function () {
    if (_this.resetCacheCallback) {
      _this.resetCacheCallback();
    }
  };

  this.onQuoteChange =
  /*#__PURE__*/
  function () {
    var _ref4 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(quotes, interval, isHeikinAshi) {
      var quotesArray;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // convert quotes object to array
              quotesArray = Object.keys(quotes).map(function (key) {
                return quotes[key];
              });
              quotesArray.forEach(function (quote) {
                if (!quote || !quote.Symbol) {
                  return;
                }

                var symbol = quote.Symbol;
                var symbolInfo = symbolInfoCache.get("".concat(symbol, "~").concat(_this.resolution));
                var listenerGuid = listenerGUIDCache.get("".concat(symbol, "~").concat(_this.resolution));
                var lastBarsCacheValue = lastBarsCache.get("".concat(symbol, "~").concat(_this.resolution));

                if (!symbolInfo || !listenerGuid || !lastBarsCacheValue) {
                  console.log('ignoring quote %O', {
                    quote: quote,
                    symbolInfo: symbolInfo,
                    listenerGuid: listenerGuid,
                    lastBarsCacheValue: lastBarsCacheValue,
                    resolution: _this.resolution,
                    symbolInfoCache: symbolInfoCache,
                    listenerGUIDCache: listenerGUIDCache,
                    lastBarsCache: lastBarsCache
                  });
                  console.debug("ignoring ".concat(symbol, "-").concat(_this.resolution, " because either bars havent loaded yet or symbolInfoCache is missing"));
                  return;
                }

                handleUpdates(symbolInfo, interval, _this.subscribeBarsCallback, listenerGuid, _this.resetCacheCallback, quote, isHeikinAshi);
              });

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x15, _x16, _x17) {
      return _ref4.apply(this, arguments);
    };
  }();

  this.api = api;
  this.bars = [];
  this.listenToQuotes = false;
  this.log = logger('DataFeed');
  this.emptyResponses = 0;
  this.symbols = [];
}; //   calculateHistoryDepth?(resolution: ResolutionString, resolutionBack: ResolutionBackValues, intervalBack: number): HistoryDepth | undefined;
// getMarks?(symbolInfo: LibrarySymbolInfo, from: number, to: number, onDataCallback: GetMarksCallback<Mark>, resolution: ResolutionString): void;
// getTimescaleMarks?(symbolInfo: LibrarySymbolInfo, from: number, to: number, onDataCallback: GetMarksCallback<TimescaleMark>, resolution: ResolutionString): void;

/**
 * This function is called if configuration flag supports_time is set to true when chart needs to know the server time.
 * The charting library expects callback to be called once.
 * The time is provided without milliseconds. Example: 1445324591. It is used to display Countdown on the price scale.
 */
// getServerTime?(callback: ServerTimeCallback): void;
// subscribeDepth?(symbolInfo: LibrarySymbolInfo, callback: DomeCallback): string;
// unsubscribeDepth?(subscriberUID: string): void;